'use strict';
import 'babel-polyfill'; // Устраняет ошибку в IE11 => https://github.com/gdi2290/NG6-starter/issues/114

/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import './_vendors/promise-polyfill';
import './_vendors/jquery';

import defaultConfig from './_default-config';

import 'magnific-popup';
import './_modules/lazy-load';
import horizontalScroll from './_modules/horizontal-scroll';
import wrapMedia from './_modules/wrap-media';
import validate from './_modules/validation/validate';
import mfpAjax from './_modules/mfp/mfp-ajax';
import mfpInline from './_modules/mfp/mfp-inline';
import mfpIframe from './_modules/mfp/mfp-iframe';
import mfpGallery from './_modules/mfp/mfp-gallery';
// import prism from './_modules/prismjs/prism';
import wsTabs from './_modules/wstabs';
import cookieData from './_modules/cookie-data';
import Notifier from './_classes/Notifier';
// import scrollBar from './_modules/scrollBar/';
import slider from './_modules/slider';
import toggle from './_modules/toggle';
import switchText from './_modules/switchText';
import selectBox from './_modules/selectBox';
import scrollToElement from './_modules/scrollToElement';
import close from './_modules/close';
import siteSearch from './_modules/site-search';
import scrollUp from './_modules/scrollUp';
import siteAccordion from './_modules/accordion';
import initFavorites from './_modules/favorites';
import setCurrency from './_modules/setCurrency';
import initFilter from './_modules/filter';
import getCurrentLang from './_utils/getCurrentLang';
import { openPopup } from './_modules/open-popup';
import { initShowMore } from './_modules/show-more';
import { initMultiSelect } from './_modules/multi-select';
import { initRangeSlider } from './_modules/range-slider';
import { initLayoutFilter } from './_modules/layout-filter';
import { currencyChanger } from './_modules/currency-changer';
import { popupSliderClose } from './_modules/popup-slider-close';
import { videoPreview } from './_modules/video-preview';
import {controlPanel} from './_modules/control-panel';

// ----------------------------------------
// Public
// ----------------------------------------

window.Noty = Notifier;

/**
 * Переопределяем обработчик window.onerror для отлова ошибок, которые выпали в глобальную облать
 * Бывает полезно, когда валятся скрипты только на мобильных и нет возможности заглянуть в консоль
 */
let oldOnerror = window.onerror;
window.onerror = function (message, url, lineNumber) {
	// let msg = `Ошибка: ${message}\n\nSource => ${url}\nLine => ${lineNumber}`;
	if (oldOnerror) {
		oldOnerror.apply(this, arguments);
	}
	// alert(msg);
	document.body.classList.add('script-error');
	document.body.classList.remove('is-loading');
	document.body.style = 'opacity: 1 !important';
};

window.jQuery(document).ready($ => {
	window.projectConfig = $.extend(true, {}, defaultConfig, window.initConfig || {});
	let $body = $('body');
	let $jsInits = $('.js-init');

	Array.prototype.forEach.call(document.forms, form => {
		form.autocomplete = 'off';
	});

	// prism();
	horizontalScroll('.wysiwyg table');
	wrapMedia('.wysiwyg iframe, .wysiwyg video');
	validate('.js-form');
	mfpAjax();
	mfpInline();
	mfpIframe();
	mfpGallery();
	popupSliderClose();
	$('.js-mfp-c').magnificPopup({
		delegate: 'a',
		type: 'image'
	});

	if ($('.js-mfp-custom')) {
		require.ensure([], (require) => {
			require('magnific-popup');
			require('magnific-popup/dist/magnific-popup.css');

			$(document).magnificPopup({
				delegate: '.js-mfp-custom',
				type: 'image',
				tLoading: 'Loading image #%curr%...',
				mainClass: '',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0, 1]
				}
			});
		}, '_js-mfp-custom');
	};

	wsTabs.init();
	wsTabs.setActive(); // если нужно принудительно активировать табы
	cookieData.askUsage(); // если нужно использовать куки

	let $sliders = $jsInits.filter('[data-slider]');
	if ($sliders.length) {
		slider($sliders.toArray());
	}

	let $togglers = $jsInits.filter('[data-toggle]');
	if ($togglers.length) {
		toggle($togglers);
	}

	let $switchTextNodes = $jsInits.filter('[data-switch-text]');
	if ($switchTextNodes.length) {
		switchText($switchTextNodes);
	}

	let $selectBoxes = $jsInits.filter('[data-select-box]');
	if ($selectBoxes.length) {
		selectBox($selectBoxes);
	}

	function importMap ($maps) {
		import('./_modules/mapBox/index').then(({ initMaps }) => {
			initMaps($maps);
		});
	}

	let $maps = $jsInits.filter('[data-map]');
	if ($maps.length) {
		if ($maps.data('map') === 'init-click') {
			$maps.on('click', function () {
				importMap($maps);
				$maps.find('.map-wait').fadeOut(300);
			});
		} else {
			importMap($maps);
		}
	}

	let $scrollTriggers = $jsInits.filter('[data-scroll-to-element]');
	if ($scrollTriggers.length) {
		$scrollTriggers.on('click.scroll', '[data-scroll-to]', (e) => {
			let $this = $(e.currentTarget);
			scrollToElement($this.data('scroll-to'));
		});
	}

	let $closeElems = $jsInits.filter('[data-close]');
	if ($closeElems.length) {
		close($closeElems);
	}

	let $siteSearchElems = $jsInits.filter('[data-live-search="site-search"]');
	if ($siteSearchElems.length) {
		siteSearch($siteSearchElems);
	}

	let $upScrollers = $jsInits.filter('[data-scroll-up]');
	if ($upScrollers.length) {
		scrollUp($upScrollers);
	}

	// let $scrollers = $('[data-scroller]');
	// if ($scrollers.length) {
	// 	*
	// 	 * Не инициализируем в IE и Edge по той причине, что вылазит странная ошибка
	// 	 * `SCRIPT70: Permission denied`
	// 	 * В будущем надо разобраться, что это за ошибка и почему вылазит.
	// 	 * Быстрый поиск показал, что чаще всего эта ошибка возникает, когда iframe пытается выполнить JS.
	// 	 * Но данный плагин не использует iframe-ы.
	// 	if (!window.Modernizr.mobiledevice && !window.Modernizr.cssscrollbar && !window.Modernizr.ie && !window.Modernizr.edge) {
	// 		scrollBar($scrollers);
	// 	}
	// }

	let $accordions = $jsInits.filter('[data-accordion]');
	if ($accordions.length) {
		siteAccordion($accordions);
	}

	let $favoriteTriggers = $jsInits.filter('[data-favorites]');
	if ($favoriteTriggers.length) {
		initFavorites($favoriteTriggers);
	}

	let $multiSelects = $jsInits.filter('[data-multiselect]');
	if ($multiSelects.length) {
		initMultiSelect($multiSelects);
	}

	let $rangeSliders = $jsInits.filter('[data-range-slider]');
	if ($rangeSliders.length) {
		initRangeSlider($rangeSliders);
	}

	let $layoutFilters = $jsInits.filter('[data-layout-filter]');
	if ($layoutFilters.length) {
		initLayoutFilter($layoutFilters);
	}

	let $currencySetters = $jsInits.filter('[data-currency-setter]');
	if ($currencySetters.length) {
		setCurrency($currencySetters);
	}

	let $currencyChangers = $jsInits.filter('[data-currency-changer]');
	if ($currencyChangers.length) {
		currencyChanger($currencyChangers);
	}

	let $filters = $jsInits.filter('[data-filter]');
	if ($filters.length) {
		initFilter($filters);
	}

	let $videoPreviews = $jsInits.filter('[data-video-preview]');
	if ($videoPreviews.length) {
		videoPreview($videoPreviews);
	}

	let $controlPanels = $jsInits.filter('[data-control-panel-trigger]');
	if ($controlPanels.length) {
		controlPanel($controlPanels);
	}

	$(window).on('scroll', function () {
		let { scrollY } = window;

		$body.toggleClass('page-is-on-top', scrollY < 150);
	}).trigger('scroll');

	$(window).on('resize', function () {}).trigger('resize');

	$body.removeClass('is-loading').addClass('is-ready');

	$('.js-phone-show').one('click', function (evt) {
		evt.preventDefault();
		$(this).find('.js-phone-text').removeAttr('style');
		$(this).find('.js-phone-ga').remove();
	});

	const $showMore = $jsInits.filter('[data-show-more]');

	if ($showMore.length) {
		initShowMore($showMore);
	}
});

window.onload = () => {
	openPopup();
};

document.oncopy = function () {
	let bodyElement = document.body;
	let selection = getSelection();
	let href = document.location.href;
	let copyright;
	if (getCurrentLang() === 'ru') {
		copyright = "<br><br>Источник: <a href='" + href + "'>" + href + '</a><br>';
	} else if (getCurrentLang() === 'ua') {
		copyright = "<br><br>Джерело: <a href='" + href + "'>" + href + '</a><br>';
	}
	let text = selection + copyright;
	let divElement = document.createElement('div');
	divElement.style.position = 'absolute';
	divElement.style.left = '-99999px';
	divElement.innerHTML = selection;
	if (divElement.innerHTML.length > 50) {
		divElement.innerHTML = text;
	}
	bodyElement.appendChild(divElement);
	selection.selectAllChildren(divElement);
	setTimeout(function () {
		bodyElement.removeChild(divElement);
	}, 0);
};

if (IS_PRODUCTION) {
	require('./_modules/wezom-log');
}



// WEBPACK FOOTER //
// ./_HTML/src/js/entry.js